export default "/images/logo-icon.png?b4abc270d8d0b2d29e3095307325c0d9";